module.exports = __webpack_public_path__ + "static/img/Icon material-edit.635420a3.svg";